import { createSlice } from '@reduxjs/toolkit';
import {
  favoriteDelete, favoriteLocalDeleteStart, favoriteLocalDeleteEnd,
  favoriteCreateReset,
} from './favoriteAsyncThunk';

const favoriteDeleteSlice = createSlice({
  name: "favorite",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [favoriteDelete.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [favoriteDelete.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [favoriteDelete.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = false;
    },
    [favoriteLocalDeleteStart]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [favoriteLocalDeleteEnd]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [favoriteCreateReset]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isFail = false;
    },
  },
});

export default favoriteDeleteSlice.reducer;